var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pageIndex",staticClass:"root"},[_c('banner',_vm._b({},'banner',{..._vm.data.banner},false)),_c('Content',{attrs:{"pageData":_vm.data.pageData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }